import { FloatingLabel, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FieldError } from "react-hook-form";

type SelectProps = {
  label: string;
  options: OptionProps[];
  register: any;
  errorsMessage?: FieldError | undefined;
  tooltipMessage?: string;
  onSelect?: (selectedValue: string | number) => void;
};

type OptionProps = {
  value?: string | number;
  label: string;
};

export const FloatSelectComponent = ({
  label,
  options,
  register,
  errorsMessage,
  tooltipMessage = "",
  onSelect,
}: React.PropsWithChildren<SelectProps>) => {
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    if (onSelect) {
      onSelect(selectedValue);
    }
  };
  const selectElement = (
    <Form.Select
      {...register}
      isInvalid={!!errorsMessage?.message}
      onChange={handleSelectChange}
    >
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  );

  return (
    <FloatingLabel label={label}>
      {tooltipMessage ? (
        <OverlayTrigger
          placement="bottom-start"
          overlay={<Tooltip id={`tooltip-${label}`}>{tooltipMessage}</Tooltip>}
        >
          {selectElement}
        </OverlayTrigger>
      ) : (
        selectElement
      )}
      {errorsMessage?.message?.toString() && (
        <Form.Control.Feedback type="invalid">
          {errorsMessage?.message?.toString()}
        </Form.Control.Feedback>
      )}
    </FloatingLabel>
  );
};

export default FloatSelectComponent;
